exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.test-fail-form-icon[data-v-54a3f03c] {\n    display: block;\n    margin: 0 auto;\n}\n", ""]);

// exports
